module.exports = __webpack_public_path__ + "static/media/Setting.b34e17a3.png";